import { Text, Transforms, Editor } from 'slate';

export default function withNormalInlineCode(editor: Editor) {
    const { normalizeNode } = editor;

    editor.normalizeNode = (entry) => {
        const [node, path] = entry;
        if (Text.isText(node) && node.code && node.text === '') {
            Transforms.setNodes(editor, { code: false }, { at: path });
        }

        normalizeNode(entry);
    };

    return editor;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('withNormalInlineCode', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
